import Detail from './Personal';
export default Detail;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/components/Personal/index.ts